"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.useKeyPressEnter = void 0;

var _react = require("react");

/**
 * Return callback that triggers 'cb' on pressing passed key or keys
 * @param {string | Array<string>} keys
 * @param {KeyboardEventHandler<*>} cb
 * @returns {KeyboardEventHandler<*>}
 */
var useKeyPressCallback = function useKeyPressCallback(keys, cb) {
  var finalKeys = (0, _react.useMemo)(function () {
    return Array.isArray(keys) ? keys : [keys];
  }, [keys]);
  return (0, _react.useCallback)(function (event) {
    if (finalKeys.includes(event.key)) {
      event.preventDefault();
      cb(event);
    }
  }, [finalKeys, cb]);
};
/**
 * Return callback that triggers 'cb' on pressing passed "Enter" key
 * @param {KeyboardEventHandler<*>} cb
 * @returns {KeyboardEventHandler<*>}
 */


var useKeyPressEnter = function useKeyPressEnter(cb) {
  return useKeyPressCallback('Enter', cb);
};

exports.useKeyPressEnter = useKeyPressEnter;
var _default = useKeyPressCallback;
exports["default"] = _default;